import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/COMP0016_2020_21_Team20/COMP0016_2020_21_Team20/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import AlertDialog from './AlertDialog';
import { Button } from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.min.css';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "alertdialog"
    }}>{`AlertDialog`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`AlertDialog`}</inlineCode>{` component is used to display an Alert on the page with given title, text, content and actions.`}</p>
    <Props of={AlertDialog} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'{/* change open from false to true to see alert */}\n<AlertDialog\n  open={false}\n  setOpen={() => null}\n  title=\"TestTitle\"\n  text=\"TestText\"\n  content=\"TestContent\"\n  actions={[<Button> test button </Button>]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      AlertDialog,
      Button,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {
        /* change open from false to true to see alert */
      }
  <AlertDialog open={false} setOpen={() => null} title="TestTitle" text="TestText" content="TestContent" actions={[<Button mdxType="Button"> test button </Button>]} mdxType="AlertDialog" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      